import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router/routes'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/main.css'
import {post} from './api/api.js';
 
Vue.config.productionTip = false

Vue.prototype.post = post
const router = new VueRouter({
  routes
})


Vue.use(ElementUI)
Vue.use(VueRouter)
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
